import type { ComponentProps } from "react";
import { forwardRef } from "react";

import { Icon } from "@/common/components-2/icon";
import { cn } from "@/services/styles/cn";

export interface MobileNavbarItemProps extends ComponentProps<"li"> {
  icon: string;
  href?: string;
  onClick?: () => void;
}

const linkClass = cn([
  "flex h-16 w-full flex-1 cursor-pointer flex-col items-center justify-center gap-0.5 border-transparent border-t-2 text-grey-600",
  "aria-current:border-tertiary-500 aria-current:text-tertiary-500",
]);

export const MobileNavbarItem = forwardRef<HTMLLIElement, MobileNavbarItemProps>(
  ({ icon, className, children, href, ...props }, ref) => {
    const content = (
      <>
        <Icon name={icon} className="text-2xl" />
        <span className="font-normal text-xs">{children}</span>
      </>
    );

    const navItem = href ? (
      <a className={linkClass} href={href}>
        {content}
      </a>
    ) : (
      <button type="button" className={linkClass}>
        {content}
      </button>
    );

    return (
      <li ref={ref} className={cn("w-full list-none text-foreground", className)} {...props}>
        {navItem}
      </li>
    );
  },
);

MobileNavbarItem.displayName = "MobileNavbarItem";
